import GalleryList from "~/components/GalleryList";
import { getLink, trans } from "~/providers/lang";
import { ROUTES } from "~/const";
import { useSeo } from "~/hooks/useSeo";
import { mainStore } from "~/stores/main";

export default function GalleryWeddingPage() {
	useSeo({
		title: trans("skelet.title.wedding"),
		canonical: "galerie-svatba",
	});

	const pageData = mainStore(state => state.data.pageData);
	const source = pageData.photos.wedding;

	return <GalleryList baseUrl={getLink(ROUTES.galleryWedding)} title={trans("template.wedding")} source={source} />;
}
